import { t as Swiper } from "./swiper.esm-Dvfjl6Fb.js";
import { t as handleProductSections } from "./product-utils-CBxrtRYw.js";
//#region src/scripts/extenders/module-selector.js
var ModuleSelector = class extends HTMLElement {
	constructor() {
		super();
		const moduleHolder = this.querySelector(".product-modules__inner");
		const moduleRadios = this.querySelectorAll(".module__radio");
		const mediaSlider = document.querySelector(".media-slider");
		const thumbs = document.querySelector(".thumbs");
		new Swiper(moduleHolder, {
			slidesPerView: window.innerWidth < 768 ? 4.45 : "auto",
			spaceBetween: 24
		});
		const selectedSwatchVariantCheck = (module, url) => {
			const correctProduct = JSON.parse(document.querySelector(".variants-data").innerHTML).filter((variant) => variant.module.includes(module));
			if (sessionStorage.getItem("selectedSwatch") !== null) {
				const selectedSwatch = sessionStorage.getItem("selectedSwatch");
				const variant = correctProduct[0]?.variants.filter((variant) => variant.title.includes(selectedSwatch));
				if (!variant || variant.length === 0 || !variant[0]?.id) location.href = url.href;
				url.searchParams.set("variant", variant[0].id);
				history.replaceState({}, `module-${module}`, url.href);
				location.href = url.href;
				handleProductSections(url.href);
			} else {
				url.searchParams.delete("variant");
				history.replaceState({}, `module-${module}`, url.href);
				location.href = url.href;
				handleProductSections(url.href);
			}
		};
		const handleModuleChange = (e) => {
			const selectedModule = e.target.value;
			const moduleLetter = e.target.dataset.moduleLetter;
			const url = new URL(window.location.href);
			const currentModule = url.pathname.replace("/products/", "");
			url.pathname = url.pathname.replace(`${currentModule}`, `${selectedModule}`);
			selectedSwatchVariantCheck(moduleLetter, url);
		};
		moduleRadios.forEach((radio) => {
			radio.addEventListener("change", (e) => {
				mediaSlider.classList.add("loading");
				thumbs.classList.add("loading");
				handleModuleChange(e);
			});
		});
	}
};
if (customElements.get("module-selector") === void 0) customElements.define("module-selector", ModuleSelector);
//#endregion
